import { PropAsset } from './PropAsset';

// Grave - Mezar
// TODO: Replace with SVG asset
export class Grave extends PropAsset {
  readonly id = 'grave';
  readonly width = 28;
  readonly height = 32;
  readonly walkable = false;
  readonly collisionRadius = 0.4;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, variant?: number): void {
    // Dirt mound - Toprak yığını
    ctx.fillStyle = '#5a4a3a';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 3 * s, 12 * s, 6 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Headstone - Mezar taşı
    ctx.fillStyle = variant === 1 ? '#5a5a5a' : '#6a6a6a';
    ctx.beginPath();
    ctx.moveTo(cx - 7 * s, cy - 5 * s);
    ctx.lineTo(cx - 7 * s, cy - 22 * s);
    ctx.quadraticCurveTo(cx - 7 * s, cy - 30 * s, cx, cy - 30 * s);
    ctx.quadraticCurveTo(cx + 7 * s, cy - 30 * s, cx + 7 * s, cy - 22 * s);
    ctx.lineTo(cx + 7 * s, cy - 5 * s);
    ctx.closePath();
    ctx.fill();

    // Headstone edge highlight
    ctx.fillStyle = 'rgba(255,255,255,0.1)';
    ctx.beginPath();
    ctx.moveTo(cx - 7 * s, cy - 22 * s);
    ctx.quadraticCurveTo(cx - 7 * s, cy - 30 * s, cx, cy - 30 * s);
    ctx.lineTo(cx, cy - 22 * s);
    ctx.closePath();
    ctx.fill();

    // Cross or symbol (variant 0 = cross, variant 1 = plain)
    if (variant !== 1) {
      ctx.fillStyle = '#4a4a4a';
      ctx.fillRect(cx - 1 * s, cy - 25 * s, 2 * s, 12 * s);
      ctx.fillRect(cx - 4 * s, cy - 22 * s, 8 * s, 2 * s);
    }

    // Cracks
    ctx.strokeStyle = '#4a4a4a';
    ctx.lineWidth = 0.5 * s;
    ctx.beginPath();
    ctx.moveTo(cx + 3 * s, cy - 20 * s);
    ctx.lineTo(cx + 2 * s, cy - 12 * s);
    ctx.stroke();
  }
}
